import { render, staticRenderFns } from "./loading.html?vue&type=template&id=f985e42c&scoped=true&"
import script from "./loading.js?vue&type=script&lang=js&"
export * from "./loading.js?vue&type=script&lang=js&"
import style0 from "./loading.scss?vue&type=style&index=0&id=f985e42c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f985e42c",
  null
  
)

export default component.exports